import { render } from "./MngJancode.vue?vue&type=template&id=211793f4&scoped=true&ts=true"
import script from "./MngJancode.vue?vue&type=script&lang=ts"
export * from "./MngJancode.vue?vue&type=script&lang=ts"

import "./MngJancode.vue?vue&type=style&index=0&id=211793f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211793f4"]])

export default __exports__